import { PSD2_CONSENTS } from 'Router/routes';
import { FakePageData } from '@4finance/cwt-test-helper';

const psd2consentsScenario: FakePageData = {
  url: PSD2_CONSENTS,
  items: {
    Continue: [
      ['[data-test="psd2Consents-checkbox-content"]', 'button'],
      ['[data-test="psd2Consents-button"]', 'button'],
    ],
  },
};

export { psd2consentsScenario };
